import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useForkRef } from '@cian/react-utils';
import classNames from 'classnames';
import * as React from 'react';
import { debounce } from 'throttle-debounce';
import { useSliderContext } from '../../utils/sliderContext';
import { useCallbackRef } from '../../utils/useCallbackRef';
import * as styles from './Scroller.css';
import { AutoScrollController } from './components/AutoScrollController';
import { Slide } from './components/Slide';
import { useSlidesDragControls } from './hooks';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Scroller = function Scroller(_ref) {
  var _initChildrenArray$cu;

  var children = _ref.children,
      onScrollEnd = _ref.onScrollEnd,
      slideWidth = _ref.slideWidth,
      columnGap = _ref.columnGap,
      slideDrag = _ref.slideDrag,
      offset = _ref.offset,
      autoScroll = _ref.autoScroll,
      autoScrollSettings = _ref.autoScrollSettings;
  var localScrollerRef = React.useRef(null);

  var _useSliderContext = useSliderContext(),
      contextScrollerRef = _useSliderContext.scrollerRef;

  var scrollerRef = useForkRef(localScrollerRef, contextScrollerRef); // eslint-disable-next-line react-hooks/exhaustive-deps

  var handleScrollEnd = React.useCallback(debounce(100, function () {
    if (onScrollEnd) {
      onScrollEnd();
    }
  }), [onScrollEnd]);
  React.useEffect(function () {
    var scrollerRef = localScrollerRef.current;

    if (!scrollerRef) {
      return;
    }

    scrollerRef.addEventListener('scroll', handleScrollEnd, {
      passive: true
    });
    return function () {
      return scrollerRef.removeEventListener('scroll', handleScrollEnd);
    };
  }, [handleScrollEnd]);
  var childrenArray = React.Children.toArray(children);
  var initChildrenArray = useCallbackRef(function () {
    return childrenArray.slice(0, 3);
  });
  React.useEffect(function () {
    initChildrenArray.current = null;
  });

  var _useSlidesDragControl = useSlidesDragControls(slideDrag),
      onMouseDown = _useSlidesDragControl.onMouseDown,
      onMouseLeave = _useSlidesDragControl.onMouseLeave,
      onMouseUp = _useSlidesDragControl.onMouseUp,
      onMouseMove = _useSlidesDragControl.onMouseMove;

  var scroller = /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("ul", {
      onMouseDown: onMouseDown,
      onMouseLeave: onMouseLeave,
      onMouseUp: onMouseUp,
      onMouseMove: onMouseMove,
      ref: scrollerRef,
      className: classNames(styles['scroller'], !!slideDrag && styles['scroller--with-drag']),
      style: {
        columnGap: columnGap
      },
      children: ((_initChildrenArray$cu = initChildrenArray.current) !== null && _initChildrenArray$cu !== void 0 ? _initChildrenArray$cu : childrenArray).map(function (child, index, arr) {
        return /*#__PURE__*/_jsx(Slide, {
          marginLeft: offset && index === 0 ? offset : undefined,
          marginRight: offset && index === arr.length - 1 ? offset : undefined,
          width: slideWidth,
          index: index,
          children: child
        }, "slide_".concat(index));
      })
    }), autoScroll && /*#__PURE__*/_jsx(AutoScrollController, _objectSpread({}, autoScrollSettings))]
  });

  if (!offset) {
    return scroller;
  }

  var containerHorizontalOffset = offset && -offset;
  return /*#__PURE__*/_jsx("div", {
    className: styles['container'],
    style: {
      marginLeft: containerHorizontalOffset,
      marginRight: containerHorizontalOffset
    },
    children: scroller
  });
};